module.exports = __webpack_public_path__ + "img/valorant-cover.a872d7fc.jpg";